"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ProfileAndLogout = _interopRequireDefault(require("./ProfileAndLogout"));

var _AccordionOption = _interopRequireDefault(require("./AccordionOption"));

var _FlatOption = _interopRequireDefault(require("./FlatOption"));

var _useOnClickOutside = require("../useOnClickOutside");

var _wrapperSidebarContext = require("../wrapperSidebarContext");

var S = _interopRequireWildcard(require("./Sidebar.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Sidebar = () => {
  var {
    accordionItems,
    hasPermiso,
    toggleSidebar,
    isSidebarOpen
  } = (0, _react.useContext)(_wrapperSidebarContext.WrapperSidebarContext);
  var sidebarRef = (0, _react.useRef)(null);
  (0, _useOnClickOutside.useOnClickOutside)(sidebarRef, () => toggleSidebar(), isSidebarOpen);
  return /*#__PURE__*/_react.default.createElement(S.Sidebar, {
    id: "sidebar",
    ref: sidebarRef
  }, " ", /*#__PURE__*/_react.default.createElement(S.AccordionGroup, {
    allowMultiple: true
  }, accordionItems.map(option => {
    if (!option.idPermiso || hasPermiso(option.idPermiso)) {
      return option.children ? /*#__PURE__*/_react.default.createElement(_AccordionOption.default, {
        accordionInfo: option,
        key: option.name
      }) : /*#__PURE__*/_react.default.createElement(_FlatOption.default, {
        accordionInfo: option,
        key: option.name
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_ProfileAndLogout.default, null));
};

var _default = Sidebar;
exports.default = _default;